import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState, useCallback } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import "../../App.css";
import "react-datepicker/dist/react-datepicker.css";
import { TextField, Grid, InputLabel, TableFooter } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "../ChangeInformation/changeInformation-styles.css";
import Skeleton from "react-loading-skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TablePagination } from "@material-ui/core";
import "moment/locale/th";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { DatePicker } from "material-ui-pickers";
import OverwriteMomentBE from "../../util/OverwriteMomentBE";
import moment from "moment";
import { IconButton, InputAdornment } from "@material-ui/core";
import AlarmIcon from "@material-ui/icons/CalendarToday";
import CircularProgress from "@mui/material/CircularProgress";
import { CustomInputText } from "../Component/CustomInputText";
import { CSVLink } from "react-csv";
import { Select, OutlinedInput, MenuItem, Backdrop } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import {
  searchRequest,
  updateTaken,
  updateCloseDate,
  getdetail,
  searchDataChangeInfo,
  cancelRequest,
} from "../RequestReport/RequestService/requestService";
import { Modal, Form, Col } from "react-bootstrap";
import { TableDetail } from "./component/TableDetail";
import successGif from "../../images/successGiff.gif";
import { getParameterAPIByVariable1 } from "../PolicyDetail/PolicyDetailService/policyDetailService";
import { policyMaintenanceAPI } from "../ChangeInformation/ChangeInformationService/changeInformationService";
import remove from "../../images/remove.png";
import warning from "../../images/warning.gif";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { CustomInputAutocomplete } from "../Component/CustomInputAutocomplete";
import { mockDataBankName } from "../BenefitReceivingHistory/mockData";
import {
  getPersonalAddressAPI,
  getPersonalAmphurAPI,
  getPersonalDistrictAPI,
  getPersonalPostalAPI,
  getPersonalProvinceAPI,
} from "../Personal/PersonalService/personalService";
import { updateRequestPersonalAPI } from "../ChangeInformation/ChangeInformationService/changeInformationService";
import {
  getPersonalNameAPI,
  getUserProfileAPI,
  getPersonalPrefixAPI,
  updatePersonalImageAPI,
  updatePersonalNameAPI,
} from "../Personal/PersonalService/personalService";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { string } from "yup";
import { getParameterAPI } from "../PolicyDetail/PolicyDetailService/policyDetailService";

const ChangeInformation = () => {
  const [loadingZip, setLoadingZip] = useState(false); // for get Zip
  const [loadingCountry, setLoadingCountry] = useState(false); // for get Zip
  const [toggleImg, setToggleImg] = useState(false);
  const [textModal, setTextModal] = useState("");
  const [completedModal, setCompletedModal] = useState(false);
  const theme = createTheme({
    components: {
      MuiTableHead: {
        styleOverrides: {
          root: {
            // backgroundColor: "#FFA500",
          },
        },
      },
    },
  });

  useEffect(() => {}, []);

  const style = {
    py: 0,
    width: "100%",
    maxWidth: 360,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  const [payDate, setPayDate] = useState(null);
  const [policyNo, setPolicyNo] = useState("");
  const [rowPayment, setRowPayment] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [refNo, setRefNo] = useState("");
  const [LoadingContent, setLoadingContent] = useState(false);
  const [spinner, setSpinner] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [requestID, setRequestID] = useState("");
  const [policyNumber, setPolicyNumber] = useState("");
  const [insurerName, setInsurerName] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("New");

  const [requestStartDate, setRequestStartDate] = useState("");
  const [requestEndDate, setRequestEndDate] = useState("");
  const [closeStartDate, setCloseStartDate] = useState("");
  const [closeEndDate, setCloseEndDate] = useState("");
  const [dataTable, setDataTable] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [prefixOptions, setPrefixOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalClose, setShowModalClose] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [selectedDetail, setSelectedDetail] = React.useState({});
  const [isDisabledTaken, setIsDisabledTaken] = useState(true);
  const [isDisabledSubmit, setIsDisabledSubmit] = useState(true);
  const [isDisabledCancle, setIsDisabledCancle] = useState(true);
  const [optionChangeType, setOptionChangeType] = useState([]);
  const [requestList, setRequestList] = useState([]);
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const [showSubmitEditModal, setShowSubmitEditModal] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [submitSuccessCount, setSubmitSuccessCount] = useState(0);
  const [submitFailCount, setSubmitFailCount] = useState(0);
  const [errorItems, setErrorItems] = useState([]);
  const [idDetail, setIdDetail] = useState("");
  const [open, setOpen] = React.useState(false);
  const [typeUpdate, setTypeUpdate] = useState("");
  const [typeOptions, setTypeOptions] = useState([]);
  const [inputErrors, setInputErrors] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [bank, setBank] = useState("");
  const [typeAddressOptions, setTypeAddressOptions] = useState([]);
  const [provinceOptions, setProvinceOptions] = useState([]);
  const [loadingProvince, setLoadingProvince] = useState(true); // for get province
  const [province, setProvince] = useState();
  const [loadingKhet, setLoadingKhet] = useState(false); // for get Khet
  const [khetOptions, setKhetOptions] = useState([]);
  const [listData, setListData] = useState([]); // เก็บข้อมูลที่ถูกเลือก
  const [khet, setKhet] = useState();
  const [provinceCode, setProvinceCode] = useState();
  const [kwangOptions, setKwangOptions] = useState([]);
  const [loadingKwang, setLoadingKwang] = useState(false); // for get Kwang
  const [khetCode, setKhetCode] = useState();
  const [kwang, setKwang] = useState();
  const [kwangCode, setKwangCode] = useState();
  const [typeRelationOptions, setTypeRelationOptions] = useState([]);
  const [zipOptions, setZipOptions] = useState([]);
  const [loadingPrefix, setLoadingPrefix] = useState(false);
  const [zip, setZip] = useState();
  const [banks, setBanks] = useState([]);

  const engPrefixOptions = (prefixOptions || [])
    .filter((item) => /^[A-Za-z .]+$/.test(item.description))
    .filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.description === item.description)
    )
    .map((item) => ({
      ...item,
      label: item.description,
      value: item.description,
    }));

  const thaiPrefixOptions = (prefixOptions || [])
    .filter((item) => /^[\u0E00-\u0E7F\s.]+$/.test(item.description))
    .map((item) => ({
      ...item,
      label: item.description,
      value: item.description,
    }));
  const [updateCreditCardObject, setUpdateCreditCardObject] = useState({
    typeUpdate: "Credit",
    fullname: "",
    creditcard_number: "",
    card_expirydate: "",
    typecard: "",
    bank: "",
    relation: "",
    realationName: "",
  });

  const [updateNameObject, setUpdateNameObject] = useState({
    typeUpdate: "Name",
    prefix_th: "",
    first_name_th: "",
    last_name_th: "",
    middle_name_th: "",
    prefix_en: "",
    first_name_en: "",
    last_name_en: "",
    middle_name_en: "",
  });

  const [updateEmailObject, setUpdateEmailObject] = useState({
    typeUpdate: "",
    email: "",
  });

  const [updateBookBankObject, setUpdateBookBankObject] = useState({
    typeUpdate: "BookBank",
    bank_name_new: "",
    bank_account_new: "",
    bank_account_name_new: "",
    prompay: "",
    prompay_account: "",
    prompay_account_name: "",
  });

  const [updateAddressObject, setUpdateAddressObject] = useState({
    typeUpdate: "Address",
    type_address: "",
    place: "",
    number: "",
    floor: "",
    zone: "",
    moohouse: "",
    build: "",
    num_build: "",
    moo: "",
    soi: "",
    road: "",
    province: "",
    district: "",
    subdistrict: "",
    postCode: "",
    country: "",
  });

  const [updateTelephoneObject, setUpdateTelephoneObject] = useState({
    typeUpdate: "Phone",
    mobile_new: "",
    phone_home_new: "",
    phone_home_to_new: "",
    phone_office_new: "",
    phone_office_to_new: "",
    phone_other_new: "",
  });

  // const [confirmStatus, setConfirmStatus] = useState({
  // });

  const [confirmStatus, setConfirmStatus] = useState("");
  const [statusBy, setStatusBy] = useState(
    (
      localStorage.getItem("first_name") +
      " " +
      localStorage.getItem("last_name")
    ).trim()
  );

  const getConvertFormat = (date) => {
    const momentDate = moment(date);
    const formattedDate = momentDate.format("YYYY-MM-DD");
    setSelectedDate(formattedDate);
  };

  const clear = async () => {
    setPolicyNumber("");
    setInsurerName("");
    setType("");
    setStatus("");
    setRequestStartDate("");
    setRequestEndDate("");
    setCloseStartDate("");
    setCloseEndDate("");
    setSelectedRows([]);
    setIsDisabledTaken(true);
    setIsDisabledSubmit(true);
    setRequestList([]);

    // เรียก API ด้วยค่าว่างโดยตรง แทนที่จะใช้ state ที่ยังไม่ได้ update
    setLoadingContent(true);
    setPage(0);
    const result = await searchDataChangeInfo("", "", "", "", "", "", "", "");
    setTimeout(() => {
      setDataTable(result.payload);
      setLoadingContent(false);
    }, 500);
  };

  const getProvince = () => {
    setLoadingProvince(true);

    // setErrorProvinceData(false);
    getPersonalProvinceAPI()
      .then((res) => {
        setLoadingProvince(false);
        if (res.success) {
          let obj = [];
          res.payload.forEach((item) => {
            obj.push({
              label: item.name,
              name: item.name,
              code: item.code,
            });
          });

          // console.log(obj)

          setProvinceOptions(obj);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoadingProvince(false);
        // setErrorProvinceData(true);
        // setOpenErrorWarning(true);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });
  };

  const getAmphur = (provinceCode) => {
    setLoadingKhet(true);
    getPersonalAmphurAPI(provinceCode)
      .then((res) => {
        setLoadingKhet(false);
        if (res.success) {
          let obj = [];
          res.payload.forEach((item) => {
            obj.push({
              label: item.name,
              name: item.name,
              code: item.code,
            });
          });

          setKhetOptions(obj);
        } else {
          setKhetOptions([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoadingKhet(false);
        // setErrorKhetData(true);
        // setOpenErrorWarning(true);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);

        setKhetOptions([]);
      });
  };

  const getSubDistrict = (khetCode) => {
    setLoadingKwang(true);
    getPersonalDistrictAPI(khetCode)
      .then((res) => {
        setLoadingKwang(false);
        if (res.success) {
          let obj = [];
          res.payload.forEach((item) => {
            obj.push({
              label: item.name,
              name: item.name,
              code: item.code,
            });
          });

          setKwangOptions(obj);
        } else {
          setKwangOptions([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoadingKwang(false);
        // setErrorKwangData(true);
        // setOpenErrorWarning(true);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);

        setKwangOptions([]);
      });
  };

  const getPrefix = () => {
    setLoadingPrefix(true);
    // setErrorPrefixData(false);
    getPersonalPrefixAPI()
      .then((res) => {
        setLoadingPrefix(false);
        if (res.success) {
          setPrefixOptions(res.payload);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoadingPrefix(false);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });
  };

  function formatDate(dateString) {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear(); /*+ 543*/
    return `${day}/${month}/${year}`;
  }

  function formatDate2(dateString) {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear(); /*+ 543*/
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hour}:${minute}`;
  }

  function formatCurrency(amount) {
    return new Intl.NumberFormat("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const toggleModalDetailOpen = (id_detail, type, policy_number, subject) => {
    setSelectedDetail({ id_detail, type, policy_number, subject }); // เก็บค่าที่เลือก
    setShowModalDetail(true); // เปิด Modal
  };

  useEffect(() => {
    getType();
    getRequest();
    getProvince();
    getPrefix();
    getBankName();
  }, []);

  const generateCsvData = (data) => {
    let data_csv = [];

    data.forEach((item) => {
      const data_row = {
        request_date: item.request_date
          ? moment(item.request_date).format("DD/MM/YYYY HH:mm")
          : "-",
        policy_number: `=""${item.policy_number}""`, // ป้องกันปัญหาการแสดงหมายเลข policy
        insurer_name: item.insurer_name,
        subject: item.subject,
        status_by: item.status_by,
        close_date: item.close_date
          ? moment(item.close_date).format("DD/MM/YYYY")
          : "-",
        status: item.status,
        Edit: item.edit,
      };
      data_csv.push(data_row);
    });

    return data_csv;
  };

  const data_csv = generateCsvData(dataTable);

  const headers = [
    { label: "Request Date", key: "request_date" },
    { label: "Policy Number", key: "policy_number" },
    { label: "Insurer Name", key: "insurer_name" },
    { label: "Subject", key: "subject" },
    { label: "Status By", key: "status_by" },
    { label: "Close Date", key: "close_date" },
    { label: "Status", key: "status" },
  ];

  const generateFilename = () => {
    const currentDate = moment().format("YYYYMMDDHHmm");
    return `CHANGE_INFORMATIOM_LOG_${currentDate}.csv`;
  };

  const getRequest = async () => {
    setLoadingContent(true);
    setPage(0);
    const result = await searchDataChangeInfo(
      policyNumber,
      insurerName,
      requestStartDate ? moment(requestStartDate).format("YYYY-MM-DD") : "",
      requestEndDate ? moment(requestEndDate).format("YYYY-MM-DD") : "",
      closeStartDate ? moment(closeStartDate).format("YYYY-MM-DD") : "",
      closeEndDate ? moment(closeEndDate).format("YYYY-MM-DD") : "",
      type,
      status
    );
    setTimeout(() => {
      // setPage(0);
      setDataTable(result.payload);
      setLoadingContent(false);
    }, 500);
  };

  const onSearch = () => {
    getRequest().then();
    // setPage(0);
    setSelectedRows([]);
    setRequestList([]);
  };

  const toggleModalDetailClose = () => {
    setShowModalDetail(false);
  };

  const handleUpdateTaken = async () => {
    if (selectedRows.length === 0) {
      alert("กรุณาเลือกรายการที่จะส่ง");
      return;
    }
    // สร้าง body ตามรูปแบบที่ต้องการ
    // console.log(selectedRows);
    const body = selectedRows.map((id) => ({ id }));

    try {
      const response = await updateTaken(body); // ส่ง body ไปยังฟังก์ชัน updateTaken
      // console.log('Update successful', response);
      setSelectedRows([]);
      toggleModalOpen();
      setIsDisabledTaken(true);
      setIsDisabledSubmit(true);
      getRequest();
      onSearch();
    } catch (error) {
      console.error("Error occurred while updating", error);
      alert("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    }
  };

  const mapTypeTextToCode = (text) => {
    switch (text) {
      case 1:
        return "CHG_ADDR";
      case 2:
        return "CHG_CREDIT_CARD";
      case 3:
        return "CHG_EMAIL";
      case 4:
        return "CHG_NAME";
      case 5:
        return "CHG_PHONE";
      case 12:
        return "UPD_BOOKBANK";
      case 13:
        return "CHG_PAYMENT_MODE";
      case 14:
        return "CHG_PAYMENT_CHANNEL";

      default:
        return "";
    }
  };

  const handleCheckboxChange = (event, id) => {
    let updatedSelectedRows;
    let updatedRequestList = [...requestList];

    const row = dataTable.find((item) => item.id === id);

    if (event.target.checked) {
      updatedSelectedRows = [...selectedRows, id];
      const processUserId = `${localStorage.getItem("first_name") || ""} ${
        localStorage.getItem("last_name") || ""
      }`;
      if (row) {
        const newItem = {
          InsureIdCard: row.customer_id,
          ChangeType: mapTypeTextToCode(row.type),
          PolicyNo: row.policy_number?.trim() || "",
          Id: row.id,
          ProcessUserId: processUserId,
          Status: row.status,
        };

        // ตรวจสอบไม่ให้ซ้ำ
        const exists = updatedRequestList.some(
          (item) =>
            item.InsureIdCard === newItem.InsureIdCard &&
            item.ChangeType === newItem.ChangeType &&
            item.PolicyNo === newItem.PolicyNo &&
            item.Id === newItem.Id
        );

        if (!exists) {
          updatedRequestList.push(newItem);
        }
      }
    } else {
      updatedSelectedRows = selectedRows.filter((rowId) => rowId !== id);

      updatedRequestList = updatedRequestList.filter(
        (item) => item.Id !== row.id
      );
    }

    setSelectedRows(updatedSelectedRows);
    setRequestList(updatedRequestList);

    const hasNonTaken = updatedSelectedRows.some((rowId) => {
      const r = dataTable.find((item) => item.id === rowId);
      return r && (r.status === "Taken" || r.status === "Pending");
    });

    if (!hasNonTaken) {
      if (isDisabledTaken) {
        setIsDisabledTaken(!isDisabledTaken);

        if (!isDisabledSubmit) {
          setIsDisabledSubmit(!isDisabledSubmit);
          setIsDisabledCancle(!isDisabledCancle);
        } else {
          setIsDisabledSubmit(isDisabledSubmit);
          setIsDisabledCancle(!isDisabledCancle);
        }
      }
    } else {
      if (isDisabledSubmit) {
        setIsDisabledSubmit(!isDisabledSubmit);
      }
      setIsDisabledTaken(isDisabledTaken);
    }

    if (updatedSelectedRows.length == 0) {
      setIsDisabledTaken(true);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (requestList.length === 0) {
      alert("กรุณาเลือกรายการที่จะส่ง");
      setLoading(false);
      return;
    }

    try {
      const result = await policyMaintenanceAPI(requestList);

      const successCount = result.filter(
        (r) => r.changeResultStatus === "00"
      ).length;
      const failCount = result.length - successCount;

      setSubmitSuccessCount(successCount);
      setSubmitFailCount(failCount);

      const errorItems = result
        .filter((r) => r.changeResultStatus !== "00")
        .map((r) => ({
          policyNo: r.policyNo,
          errorMessage: r.changeResultMessage,
        }));

      setErrorItems(errorItems);
      console.log("Error Items:", errorItems);

      // ตั้งค่า status ตามจำนวนสำเร็จ/ไม่สำเร็จ
      if (successCount === result.length) {
        setSubmitStatus("success"); // สำเร็จทั้งหมด
      } else if (successCount === 0) {
        setSubmitStatus("error"); // ไม่สำเร็จเลย
      } else {
        setSubmitStatus("partial"); // บางส่วนสำเร็จ
      }
    } catch (err) {
      console.error(err);
      setSubmitStatus("error");

      setSubmitSuccessCount(0);
      setSubmitFailCount(requestList.length);

      const fallbackErrorItems = requestList.map((r) => ({
        policyNo: r.policyNo,
        errorMessage: "ไม่สามารถเชื่อมต่อระบบ",
      }));

      setErrorItems(fallbackErrorItems);
    }

    setLoading(false);
    toggleSubmitModalOpen();
    setIsDisabledTaken(true);
    setIsDisabledSubmit(true);
    setSelectedRows([]);
    setRequestList([]);
    // toggleSubmitEditModalOpen();
    getRequest();
    onSearch();
  };

  const handleCancel = () => {
    console.log(selectedRows);
    console.log(status);
    toggleCancelModalOpen();
  };

  const toggleModalOpen = () => {
    setShowModal(true);
  };

  const toggleModalClose = () => {
    setShowModal(false);
  };
  const toggleSubmitModalOpen = () => {
    setShowSubmitModal(true);
  };

  const toggleSubmitModalClose = () => {
    setShowSubmitModal(false);
  };

  const toggleCancelModalOpen = () => {
    setShowCancelModal(true);
    //console.log("38dac1dc-a183-41e4-a9ed-6148aff5b4c7")
    console.log("todsob");
  };

  const toggleCancelModalClose = () => {
    console.log(selectedRows);
    setShowCancelModal(false);
  };

  const handleConfirmCancel = async () => {
    const nextStatus = "Canceled";
    setConfirmStatus(nextStatus);
    toggleCancelModalClose();

    try {
      const result = await cancelRequest(selectedRows, statusBy, nextStatus);
      if (!result?.updated || result.updated.length === 0) {
        throw new Error("No rows were updated.");
      }
    } catch (err) {
      console.error(err);
    }
    getRequest();
    setSelectedRows([]);
    setRequestList([]);
    setIsDisabledCancle(true);
    setIsDisabledSubmit(true);

    console.log({ statusBy, nextStatus, selectedRows });
  };

  const toggleSubmitEditModalOpen = () => {
    setShowSubmitEditModal(true);
  };
  const toggleSubmitEditModalClose = () => {
    setShowSubmitEditModal(false);
  };

  const getType = async () => {
    const result = await getParameterAPIByVariable1("CHANGE_DATA");
    const payload = result.payload;

    // const changeType = payload.filter((item) =>
    //   [1, 2, 3, 4, 5, 13, 14].includes(Number(item.name))

    // );

    setOptionChangeType(payload);
  };

  const handleClickOpen = async (id_detail, type, insurer_name, subject) => {
    setIdDetail(id_detail);
    const result = await getdetail(id_detail, type);

    const data = result.payload[0];
    if (subject === "เปลี่ยนบัตรเครดิต") {
      setUpdateCreditCardObject((prev) => ({
        fullname: data.card_holder_name_new,
        creditcard_number: data.card_number_new,
        card_expirydate: data.card_expire_date_new.trim(),
        typecard: data.card_type_new.trim(),
        bank: data.credit_bank_name_new,
        relation: data.card_relation_new.trim(),
        realationName: data.card_relation_name_new,
      }));
    } else if (subject === "เปลี่ยนชื่อ") {
      setUpdateNameObject((prev) => ({
        prefix_th: data.title_new,
        first_name_th: data.first_name_new,
        last_name_th: data.last_name_new,
        middle_name_th: data.middle_name_new,
        prefix_en: data.title_en_new,
        first_name_en: data.first_name_en_new,
        last_name_en: data.last_name_en_new,
        middle_name_en: data.middle_name_en_new,
      }));
    } else if (subject === "เปลี่ยน email") {
      setUpdateEmailObject((prev) => ({
        email: data.email_new,
      }));
    } else if (subject === "เปลี่ยนบัญชีธนาคาร") {
      if (null !== data.promt_pay_account) {
        setUpdateBookBankObject((prev) => ({
          bank_name_new: "",
          bank_account_new: "",
          bank_account_name_new: "",
          prompay: "พร้อมเพย์",
          prompay_account: data.promt_pay_account,
          prompay_account_name: data.promt_pay_account_name,
        }));
      } else {
        setUpdateBookBankObject((prev) => ({
          bank_name_new: data.bank_name_new,
          bank_account_new: data.bank_account_new,
          bank_account_name_new: data.bank_account_name_new,
          prompay: "",
          prompay_account: "",
          prompay_account_name: "",
        }));
      }
    } else if (subject === "เปลี่ยนที่อยู่") {
      setUpdateAddressObject((prev) => ({
        type_address: data.addrType,
        place: data.place,
        number: data.addrNo,
        floor: data.floor,
        zone: data.zone,
        moohouse: data.villageName,
        build: data.buildName,
        num_build: data.buildNo,
        moo: data.moo,
        soi: data.soi,
        road: data.road,
        province: data.provinceName.trim(),
        district: data.amphurName.trim(),
        subdistrict: data.tambolName,
        postCode: data.postCode,
        country: data.countryName,
      }));
    } else if (subject === "เปลี่ยนเบอร์โทร") {
      setUpdateTelephoneObject((prev) => ({
        mobile_new: data.mobile_new,
        phone_home_new: data.phone_home_new,
        phone_home_to_new: data.phone_home_to_new,
        phone_office_new: data.phone_office_new,
        phone_office_to_new: data.phone_office_to_new,
        phone_other_new: data.phone_other_new,
      }));
    }

    const newSubject = subject.replace("เปลี่ยน", "แก้ไข");
    setTypeUpdate(newSubject);
    setOpen(true);
  };

  useEffect(() => {
    // setProvinceCode
  }, [
    updateCreditCardObject,
    updateNameObject,
    updateEmailObject,
    updateAddressObject,
    updateTelephoneObject,
  ]);

  useEffect(() => {
    setTypeOptions(cardTypes);
    setBankOptions(banks);
  }, []);

  useEffect(() => {
    setTypeAddressOptions(AddressDataOptions);
  }, []);

  useEffect(() => {
    setTypeRelationOptions(RelationDataOptions);
    setBank(bankDataOptions);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const updateField = (key, value) => {
    setUpdateCreditCardObject((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const updateFieldNameObj = (key, value) => {
    setUpdateNameObject((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const updateFieldEmailObj = (key, value) => {
    setUpdateEmailObject((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const updateFieldBankObj = (key, value) => {
    setUpdateBookBankObject((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const updateFieldAddressObj = (key, value) => {
    setUpdateAddressObject((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const updateFieldTelephoneObj = (key, value) => {
    setUpdateTelephoneObject((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const updatepersona = async () => {
    let bodyPayload = {};
    let requestBody = {};
    if (typeUpdate === "แก้ไขที่อยู่") {
      bodyPayload = {
        typeUpdate: typeUpdate,
        idDetail: idDetail,
        address: updateAddressObject,
      };
    } else if (typeUpdate === "แก้ไขบัตรเครดิต") {
      bodyPayload = {
        typeUpdate: typeUpdate,
        idDetail: idDetail,
        credit: updateCreditCardObject,
      };
    } else if (typeUpdate === "แก้ไขชื่อ") {
      bodyPayload = {
        typeUpdate: typeUpdate,
        idDetail: idDetail,
        name: updateNameObject,
      };
    } else if (typeUpdate === "แก้ไข email") {
      bodyPayload = {
        typeUpdate: typeUpdate,
        idDetail: idDetail,
        email: updateEmailObject,
      };
    } else if (typeUpdate === "แก้ไขบัญชีธนาคาร") {
      bodyPayload = {
        typeUpdate: typeUpdate,
        idDetail: idDetail,
        bookbank: updateBookBankObject,
      };
    } else if (typeUpdate === "แก้ไขเบอร์โทร") {
      bodyPayload = {
        typeUpdate: typeUpdate,
        idDetail: idDetail,
        phone: updateTelephoneObject,
      };
    } else {
      console.warn("ไม่พบ typeUpdate ที่ตรงกัน:", typeUpdate);
    }

    // Add typeUpdate to bodyPayload
    bodyPayload = {
      ...bodyPayload,
      typeUpdate: typeUpdate,
    };

    // Debug log
    console.log("เลือก typeUpdate:", typeUpdate);
    console.log("payload ที่จะส่ง:", bodyPayload);

    try {
      const response = await updateRequestPersonalAPI(bodyPayload);
      console.log("Update success:", response);
      // Set success status and show modal
      setSubmitStatus("success");
      setResponseMessage(response.message || "ระบบแก้ไขข้อมูลเรียบร้อย");
      setOpen(false);
      toggleSubmitEditModalOpen();
    } catch (error) {
      console.error("Update error:", error);
      // Set error status and show modal
      setSubmitStatus("error");
      setResponseMessage(error.message || "ไม่สามารถแก้ไขข้อมูลได้");
      toggleSubmitEditModalOpen();
    }
  };

  const Cancelpersona = async () => {
    setOpen(false);
  };
  const removeInputError = (inputId) => {
    setInputErrors((errors) => errors.filter((err) => err !== inputId));
  };

  const fetchAmphur = useCallback(
    async (code) => {
      await getAmphur(code); // เดิมคุณมี getAmphur อยู่แล้ว ก็ห่อด้วย useCallback
    },
    [] // ใส่ dependency ตามจริงถ้ามี
  );

  useEffect(() => {
    if (!updateAddressObject.province) {
      setProvinceCode("");

      return;
    }

    const found = provinceOptions.find(
      (opt) => opt.name === updateAddressObject.province
    );

    if (!found) {
      setProvinceCode("");

      return;
    }

    // เซ็ตเฉพาะเมื่อ code เปลี่ยนจริง ๆ เพื่อลด re-render ไม่จำเป็น
    setProvinceCode((prev) => (prev === found.code ? prev : found.code));
    fetchAmphur(found.code);
  }, [updateAddressObject.province, provinceOptions, fetchAmphur]);

  const fetchTambol = useCallback(
    async (code) => {
      await getSubDistrict(code); // เดิมคุณมี getAmphur อยู่แล้ว ก็ห่อด้วย useCallback
    },
    [] // ใส่ dependency ตามจริงถ้ามี
  );

  useEffect(() => {
    if (!updateAddressObject.district) {
      setKhetCode("");

      return;
    }

    const found = khetOptions.find(
      (opt) => opt.name === updateAddressObject.district
    );

    if (!found) {
      setKhetCode("");

      return;
    }

    // เซ็ตเฉพาะเมื่อ code เปลี่ยนจริง ๆ เพื่อลด re-render ไม่จำเป็น
    setKhetCode((prev) => (prev === found.code ? prev : found.code));
    fetchTambol(found.code);
  }, [updateAddressObject.district, khetOptions, fetchTambol]);

  // Update kwangCode when subdistrict changes
  useEffect(() => {
    if (!updateAddressObject.subdistrict) {
      setKwangCode("");
      return;
    }

    const found = kwangOptions.find(
      (opt) => opt.name === updateAddressObject.subdistrict
    );

    if (!found) {
      setKwangCode("");
      return;
    }

    // Set kwangCode only when it actually changes to reduce unnecessary re-renders
    setKwangCode((prev) => (prev === found.code ? prev : found.code));
  }, [updateAddressObject.subdistrict, kwangOptions]);

  // Fetch postal codes when both khetCode and kwangCode are available
  useEffect(() => {
    if (khetCode && kwangCode) {
      getPostal(khetCode, kwangCode);
    }
  }, [khetCode, kwangCode]);

  const getPostal = (khetCode, kwangCode) => {
    setLoadingZip(true);
    // setErrorZipData(false);
    getPersonalPostalAPI(khetCode, kwangCode)
      .then((res) => {
        setLoadingZip(false);
        if (res.success) {
          let obj = [];
          res.payload.forEach((item) => {
            obj.push({
              label: item.zip,
              name: item.zip,
              code: item.zip,
            });
          });

          setZipOptions(obj);
          const activeZip = res.payload.filter((item) => item.active === true);
          if (activeZip.length > 0) {
            const zipValue = activeZip[0].zip;
            setZip(zipValue);
            updateFieldAddressObj("postCode", zipValue);
          }
        } else {
          setZipOptions([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoadingZip(false);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);

        setZipOptions([]);
      });
  };

  const bankOpt = (banks ?? [])
    .filter((b) => b?.flagActive === "Y")
    .map((b) => ({
      label: b.name, // แสดงชื่อธนาคาร
      value: b.name, // ส่งค่ากลับเป็นชื่อธนาคาร
      code: b.code, // เก็บ code ไว้เผื่อใช้ (ไม่แสดง/ไม่ส่ง)
    }))
    .sort((a, b) => a.label.localeCompare(b.label, "th"));

  const renderInputForEdit = () => {
    if (typeUpdate === "แก้ไขบัตรเครดิต") {
      return (
        <>
          <Grid item xs={12} md={3}>
            <CustomInputText
              id="input-fullname"
              label="ชื่อนามสกุล"
              placeholder="ชื่อ นามสกุล"
              value={updateCreditCardObject.fullname}
              onChange={(e) => updateField("fullname", e.target.value)}
              InputProps={{ style: { borderRadius: "16px", height: 41 } }}
            />
          </Grid>
          <br />
          <Grid item xs={12} md={3}>
            <CustomInputText
              id="input-fullname"
              label="หมายเลขบัตร"
              placeholder="หมายเลขบัตร"
              value={updateCreditCardObject.creditcard_number}
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, ""); // กรองให้เหลือแต่ตัวเลข
                if (onlyNums.length <= 16) {
                  updateField("creditcard_number", onlyNums);
                }
              }}
              InputProps={{ style: { borderRadius: "16px", height: 41 } }}
            />
          </Grid>
          <br />
          <Grid item xs={12} md={3}>
            <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
              เดือน/ปี หมดอายุของบัตร
            </label>
            <MuiPickersUtilsProvider
              utils={OverwriteMomentBE}
              locale="th"
              moment={moment}
            >
              <DatePicker
                views={["year", "month"]} // เลือกแค่ เดือน/ปี
                format="MM/YY" // แสดงผล 2 หลัก (เช่น 03/30)
                pickerHeaderFormat="MM/YY"
                placeholder="เดือน/ปี หมดอายุของบัตร"
                value={
                  updateCreditCardObject.card_expirydate
                    ? moment(updateCreditCardObject.card_expirydate, "MM/YY")
                    : null
                }
                onChange={(date) => {
                  const formatted = date
                    ? moment(date).locale("en").format("MM/YY")
                    : "";
                  updateField("card_expirydate", formatted); // เก็บกลับเป็น "MM/YY"
                }}
                fullWidth
                autoOk
                InputProps={{
                  style: { borderRadius: "16px", height: 41 },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <AlarmIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
                style={{ borderRadius: "16px", height: 41 }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <br />
          <Grid item xs={12} md={3}>
            <CustomInputAutocomplete
              id="input-type"
              label="ประเภทของบัตร"
              placeholder="กรุณาเลือก"
              // value={
              //     typeOptions.find((opt) => opt.value === updateCreditCardObject.typecard) || null
              // }
              value={
                typeOptions.find((opt) =>
                  (opt.value ?? "")
                    .toLowerCase()
                    .includes(
                      (updateCreditCardObject.typecard ?? "")
                        .trim()
                        .toLowerCase()
                    )
                ) || null
              }
              onChange={(value) => {
                updateField("typecard", value?.value ?? "");
                removeInputError("input-type");
              }}
              options={typeOptions || []}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              error={inputErrors.includes("input-type")}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "16px",
                  height: 42,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <CustomInputAutocomplete
              id="input-bank"
              label="ธนาคารเจ้าของบัตรเครดิต"
              placeholder="กรุณาเลือก"
              value={
                bankOpt.find((opt) =>
                  (opt.value ?? "")
                    .toLowerCase()
                    .includes(
                      (updateCreditCardObject.bank ?? "").trim().toLowerCase()
                    )
                ) || null
              }
              onChange={(value) => {
                updateField("bank", value?.value ?? "");
                removeInputError("input-bank");
              }}
              options={bankOpt || []}
              getOptionLabel={(option) => option?.label ?? ""} // 🔹 บอกว่าจะโชว์อะไรบนช่อง
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              } // 🔹 เทียบความเท่ากัน
              // (ถ้า component รองรับ sx)
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "16px",
                  height: 42,
                },
              }}
            />
          </Grid>

          {updateCreditCardObject.relation === "ตนเอง" ? (
            <Grid item xs={12} md={3}>
              <CustomInputAutocomplete
                id="input-relation"
                label="ความสัมพันธ์เจ้าของบัตรเครดิตผู้เอาประกันภัย"
                placeholder="กรุณาเลือก"
                value={
                  typeRelationOptions.find((opt) =>
                    (opt.value ?? "")
                      .toLowerCase()
                      .includes(
                        (updateCreditCardObject.relation ?? "")
                          .trim()
                          .toLowerCase()
                      )
                  ) || null
                }
                onChange={(value) => {
                  updateField("relation", value?.value ?? "");
                  removeInputError("input-relation"); // เดิมพิมพ์ผิดเป็น input-type
                }}
                options={typeRelationOptions || []}
                getOptionLabel={(option) => option?.label ?? ""} // 🔹 บอกว่าจะโชว์อะไรบนช่อง
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // 🔹 เทียบความเท่ากัน
                // (ถ้า component รองรับ sx)
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "16px",
                    height: 42,
                  },
                }}
              />
            </Grid>
          ) : (
            <>
              <Grid item xs={12} md={3}>
                <CustomInputAutocomplete
                  id="input-relation"
                  label="ความสัมพันธ์เจ้าของบัตรเครดิตผู้เอาประกันภัย"
                  placeholder="กรุณาเลือก"
                  value={
                    typeRelationOptions.find((opt) =>
                      (opt.value ?? "")
                        .toLowerCase()
                        .includes(
                          (updateCreditCardObject.relation ?? "")
                            .trim()
                            .toLowerCase()
                        )
                    ) || null
                  }
                  onChange={(value) => {
                    updateField("relation", value?.value ?? "");
                    removeInputError("input-relation"); // เดิมพิมพ์ผิดเป็น input-type
                  }}
                  options={typeRelationOptions || []}
                  getOptionLabel={(option) => option?.label ?? ""} // 🔹 บอกว่าจะโชว์อะไรบนช่อง
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  } // 🔹 เทียบความเท่ากัน
                  // (ถ้า component รองรับ sx)
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "16px",
                      height: 42,
                    },
                  }}
                />
              </Grid>
              <br />
              <Grid item xs={12} md={3}>
                <CustomInputText
                  id="input-fullname"
                  label="ชื่อ นามสกุล"
                  placeholder=""
                  value={updateCreditCardObject.realationName}
                  onChange={(e) => updateField("realationName", e.target.value)}
                  InputProps={{ style: { borderRadius: "16px", height: 42 } }}
                />
              </Grid>
            </>
          )}
        </>
      );
    } else if (typeUpdate === "แก้ไขชื่อ") {
      return (
        <>
          <Grid item xs={12} md={3}>
            <CustomInputAutocomplete
              id="input-fullname"
              label="คำนำหน้า"
              placeholder="กรุณาเลือก"
              value={selectedPrefixTh}
              onChange={(value) => {
                updateFieldNameObj("prefix_th", value?.value ?? "");
                removeInputError("input-fullname");
              }}
              options={thaiPrefixOptions || []}
              getOptionLabel={(option) => option?.label ?? ""} // 🔹 บอกว่าจะโชว์อะไรบนช่อง
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              } // 🔹 เทียบความเท่ากัน
              // (ถ้า component รองรับ sx)
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "16px",
                  height: 42,
                },
              }}
            />
          </Grid>
          <br />
          <Grid item xs={12} md={3}>
            <CustomInputText
              id="input-fullname"
              label="ชื่อ(ภาษาไทย)"
              placeholder="ชื่อ(ภาษาไทย)"
              value={updateNameObject.first_name_th}
              onChange={(e) =>
                updateFieldNameObj("first_name_th", e.target.value)
              }
              onBlur={(e) =>
                updateFieldNameObj("first_name_th", e.target.value.trim())
              }
              InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
            />
          </Grid>
          <br />
          <Grid item xs={12} md={3}>
            <CustomInputText
              id="input-fullname"
              label="นามสกุล(ภาษาไทย)"
              placeholder="นามสกุล(ภาษาไทย)"
              value={updateNameObject.last_name_th}
              onChange={(e) =>
                updateFieldNameObj("last_name_th", e.target.value)
              }
              onBlur={(e) =>
                updateFieldNameObj("last_name_th", e.target.value.trim())
              }
              InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
            />
          </Grid>
          <br />
          <Grid item xs={12} md={3}>
            <CustomInputText
              id="input-fullname"
              label="ชื่อกลาง(ภาษาไทย)"
              placeholder="ชื่อกลาง(ภาษาไทย)"
              value={updateNameObject.middle_name_th}
              onChange={(e) =>
                updateFieldNameObj("middle_name_th", e.target.value)
              }
              onBlur={(e) =>
                updateFieldNameObj("middle_name_th", e.target.value.trim())
              }
              InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
            />
          </Grid>

          <br />
          <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color: "#908f8eff",
            }}
          />
          <br />

          <Grid item xs={12} md={3}>
            {/*<CustomInputText*/}
            {/*    id="input-fullname"*/}
            {/*    label="Title"*/}
            {/*    placeholder="Title"*/}
            {/*    value={updateNameObject.prefix_en}*/}
            {/*    onChange={(e) => updateFieldNameObj("prefix_en", e.target.value)}*/}
            {/*    InputProps={{style: {borderRadius: "16px", height: "42px"}}}*/}
            {/*/>*/}
            <CustomInputAutocomplete
              id="input-fullname"
              label="Title"
              placeholder="Please select"
              value={selectedPrefixEn}
              onChange={(value) => {
                updateFieldNameObj("prefix_en", value?.value ?? "");
                removeInputError("input-fullname"); // เดิมพิมพ์ผิดเป็น input-type
              }}
              options={engPrefixOptions || []}
              getOptionLabel={(option) => option?.label ?? ""} // 🔹 บอกว่าจะโชว์อะไรบนช่อง
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              } // 🔹 เทียบความเท่ากัน
              disableClearable={false} // ให้เคลียร์ได้
              // (ถ้า component รองรับ sx)
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "16px",
                  height: 42,
                },
              }}
            />
          </Grid>
          <br />
          <Grid item xs={12} md={3}>
            <CustomInputText
              id="input-fullname"
              label="FirstName"
              placeholder="FirstName"
              value={updateNameObject.first_name_en}
              onChange={(e) =>
                updateFieldNameObj("first_name_en", e.target.value)
              }
              onBlur={(e) =>
                updateFieldNameObj("first_name_en", e.target.value.trim())
              }
              InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
            />
          </Grid>
          <br />
          <Grid item xs={12} md={3}>
            <CustomInputText
              id="input-fullname"
              label="LastName"
              placeholder="LastName"
              value={updateNameObject.last_name_en}
              onChange={(e) =>
                updateFieldNameObj("last_name_en", e.target.value)
              }
              onBlur={(e) =>
                updateFieldNameObj("last_name_en", e.target.value.trim())
              }
              InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
            />
          </Grid>
          <br />
          <Grid item xs={12} md={3}>
            <CustomInputText
              id="input-fullname"
              label="Middle Name"
              placeholder="Middle Name"
              value={updateNameObject.middle_name_en}
              onChange={(e) =>
                updateFieldNameObj("middle_name_en", e.target.value)
              }
              onBlur={(e) =>
                updateFieldNameObj("middle_name_en", e.target.value.trim())
              }
              InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
            />
          </Grid>
        </>
      );
    } else if (typeUpdate === "แก้ไข email") {
      return (
        <>
          <Grid item xs={12} md={3}>
            <CustomInputText
              id="input-email"
              label="อีเมล"
              placeholder="example@g.com"
              type="email"
              value={updateEmailObject.email}
              onChange={(e) => {
                const noSpaces = e.target.value.replace(/\s/g, ""); // ลบทุกช่องว่าง
                updateFieldEmailObj("email", noSpaces);
              }}
              error={
                updateEmailObject.email !== "" &&
                !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(updateEmailObject.email)
              }
              helperText={
                updateEmailObject.email !== "" &&
                !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(updateEmailObject.email)
                  ? "รูปแบบอีเมลไม่ถูกต้อง"
                  : ""
              }
              InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
            />
          </Grid>
        </>
      );
    } else if (typeUpdate === "แก้ไขบัญชีธนาคาร") {
      return (
        <>
          {(updateBookBankObject.prompay ?? "").trim() !== "พร้อมเพย์" ? (
            <>
              <Grid item xs={12} md={3}>
                <CustomInputText
                  id="input-accountName"
                  label="ชื่อบัญชี"
                  placeholder="ชื่อบัญชี"
                  value={updateBookBankObject.bank_account_name_new ?? ""}
                  onChange={(e) =>
                    updateFieldBankObj("bank_account_name_new", e.target.value)
                  }
                  InputProps={{
                    style: { borderRadius: "16px", height: "42px" },
                  }}
                />
              </Grid>

              <br />
              <Grid item xs={12} md={3}>
                <CustomInputAutocomplete
                  id="input-bank_name_new"
                  label="ธนาคาร"
                  placeholder="กรุณาเลือก"
                  value={
                    bankOpt.find(
                      (o) =>
                        o.value === (updateBookBankObject.bank_name_new ?? "")
                    ) || null
                  }
                  onChange={(option) => {
                    // เก็บเป็น 'ชื่อธนาคาร' ตรง ๆ
                    updateFieldBankObj("bank_name_new", option?.value ?? "");
                    removeInputError("input-bank_name_new");
                    // ถ้าจะเก็บ code เพิ่มด้วย:
                    // updateFieldBankObj("bank_code_new", option?.code ?? "");
                  }}
                  options={bankOpt}
                  getOptionLabel={(option) => option?.label ?? ""}
                  isOptionEqualToValue={(option, value) =>
                    option?.value === value?.value
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "16px",
                      height: 42,
                    },
                  }}
                />
              </Grid>
              <br />
              <Grid item xs={12} md={3}>
                <CustomInputText
                  id="input-accountNo"
                  label="เลขที่บัญชี"
                  placeholder="เลขที่บัญชี"
                  value={updateBookBankObject.bank_account_new ?? ""}
                  onChange={(e) => {
                    const digits = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10); // เอาเฉพาะตัวเลข + ตัดให้เหลือ 10
                    updateFieldBankObj("bank_account_new", digits);
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const pasted = e.clipboardData
                      .getData("text")
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    updateFieldBankObj("bank_account_new", pasted);
                  }}
                  InputProps={{
                    style: { borderRadius: "16px", height: "42px" },
                  }}
                  inputProps={{
                    maxLength: 10,
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12} md={3}>
                <CustomInputText
                  id="input-accountName"
                  label="ชื่อบัญชีพร้อมเพย์"
                  placeholder="ชื่อบัญชีพร้อมเพย์"
                  value={updateBookBankObject.prompay_account_name ?? ""}
                  onChange={(e) =>
                    updateFieldBankObj("prompay_account_name", e.target.value)
                  }
                  InputProps={{
                    style: { borderRadius: "16px", height: "42px" },
                  }}
                />
              </Grid>

              <br />
              <Grid item xs={12} md={3}>
                <CustomInputText
                  id="input-promptPayId"
                  label="เลขที่พร้อมเพย์"
                  placeholder="เลขที่พร้อมเพย์"
                  value={updateBookBankObject.prompay_account ?? ""}
                  onChange={(e) =>
                    updateFieldBankObj("prompay_account", e.target.value)
                  }
                  InputProps={{
                    style: { borderRadius: "16px", height: "42px" },
                  }}
                  inpurProps={{ maxLength: 10 }}
                />
              </Grid>
            </>
          )}
        </>
      );
    } else if (typeUpdate === "แก้ไขที่อยู่") {
      return (
        <>
          <Grid container md={12}>
            <Grid item xs={6} md={6}>
              <CustomInputAutocomplete
                id="input-type"
                label="ประเภทที่อยู่"
                placeholder="กรุณาเลือก"
                value={
                  typeAddressOptions.find((opt) =>
                    (opt.label ?? "")
                      .toLowerCase()
                      .includes(
                        (updateAddressObject.type_address ?? "")
                          .trim()
                          .toLowerCase()
                      )
                  ) || null
                }
                onChange={(value) => {
                  updateFieldAddressObj("type_address", value?.value ?? "");
                  removeInputError("input-type"); // เดิมพิมพ์ผิดเป็น input-type
                }}
                options={typeAddressOptions || []}
                getOptionLabel={(option) => option?.label ?? ""} // 🔹 บอกว่าจะโชว์อะไรบนช่อง
                isOptionEqualToValue={(option, value) =>
                  option.label === value.label
                } // 🔹 เทียบความเท่ากัน
                // (ถ้า component รองรับ sx)
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "16px",
                    height: 42,
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-fullname"
                label="สถานที่"
                placeholder="สถานที่"
                value={updateAddressObject.place}
                onChange={(e) => updateFieldAddressObj("place", e.target.value)}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>
          </Grid>

          <br />

          <Grid container md={12}>
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-fullname"
                label="เลขที่"
                placeholder="เลขที่"
                value={updateAddressObject.number}
                onChange={(e) =>
                  updateFieldAddressObj("number", e.target.value)
                }
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>
            <br />
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-fullname"
                label="ชั้น"
                placeholder="ชั้น"
                value={updateAddressObject.floor}
                onChange={(e) => updateFieldAddressObj("floor", e.target.value)}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>
          </Grid>
          <br />
          {/* <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color: "#908f8eff",
            }}
          />
          <br /> */}
          <Grid container md={12}>
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-fullname"
                label="โซน"
                placeholder="โซน"
                value={updateAddressObject.zone}
                onChange={(e) => updateFieldAddressObj("zone", e.target.value)}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>
            <br />
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-fullname"
                label="หมู่บ้าน"
                placeholder="หมู่บ้าน"
                value={updateAddressObject.moohouse}
                onChange={(e) =>
                  updateFieldAddressObj("moohouse", e.target.value)
                }
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>
          </Grid>

          <br />

          <Grid container md={12}>
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-fullname"
                label="อาคาร"
                placeholder="อาคาร"
                value={updateAddressObject.build}
                onChange={(e) => updateFieldAddressObj("build", e.target.value)}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>

            <br />
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-fullname"
                label="อาคารเลขที่"
                placeholder="อาคารเลขที่"
                value={updateAddressObject.num_build}
                onChange={(e) =>
                  updateFieldAddressObj("num_build", e.target.value)
                }
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>
          </Grid>
          <br />
          <Grid container md={12}>
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-fullname"
                label="หมู่ที่"
                placeholder="หมู่ที่"
                value={updateAddressObject.moo}
                onChange={(e) => updateFieldAddressObj("moo", e.target.value)}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>
            <br />
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-fullname"
                label="ซอย"
                placeholder="ซอย"
                value={updateAddressObject.soi}
                onChange={(e) => updateFieldAddressObj("soi", e.target.value)}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>
          </Grid>
          <br />
          <Grid container md={12}>
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-fullname"
                label="ถนน"
                placeholder="ถนน"
                value={updateAddressObject.road}
                onChange={(e) => updateFieldAddressObj("road", e.target.value)}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>
            <br />
            <Grid item xs={6} md={6}>
              <CustomInputAutocomplete
                id="input-province"
                label="จังหวัด"
                placeholder="กรุณาเลือก"
                value={
                  provinceOptions.find(
                    (opt) => opt.name === updateAddressObject.province
                  ) || null
                }
                onChange={(newValue) => {
                  updateFieldAddressObj("province", newValue?.name ?? ""); // เก็บ name
                  removeInputError("input-province"); // แก้ id ให้ถูก
                  // Clear district, subdistrict, and postal code when province changes
                  updateFieldAddressObj("district", "");
                  updateFieldAddressObj("subdistrict", "");
                  updateFieldAddressObj("postCode", "");
                  setKhetOptions([]);
                  setKwangOptions([]);
                  setZipOptions([]);
                  setZip("");
                }}
                options={provinceOptions || []}
                getOptionLabel={(option) => option?.label ?? option?.name ?? ""}
                isOptionEqualToValue={(option, value) =>
                  option?.name === value?.name
                }
                loading={loadingProvince}
                error={inputErrors.includes("input-province")}
              />
            </Grid>
          </Grid>
          <br />

          <Grid container md={12}>
            <Grid item xs={6} md={6}>
              <CustomInputAutocomplete
                id="input-amphurName"
                label="เขต/อำเภอ"
                placeholder="กรุณาเลือก"
                value={
                  (khetOptions || []).find(
                    (opt) => opt.name === updateAddressObject.district
                  ) || null
                }
                onChange={(newValue) => {
                  updateFieldAddressObj("district", newValue?.name ?? "");
                  removeInputError("input-amphurName");
                }}
                options={khetOptions || []}
                getOptionLabel={(option) => option?.label ?? option?.name ?? ""}
                isOptionEqualToValue={(option, value) =>
                  option?.name === value?.name
                }
                loading={loadingKhet}
                error={inputErrors.includes("input-amphurName")}
              />
            </Grid>
            <br />

            <Grid item xs={6} md={6}>
              <CustomInputAutocomplete
                id="input-tambolName"
                label="แขวง/ตำบล"
                placeholder="กรุณาเลือก"
                value={
                  (kwangOptions || []).find(
                    (opt) => opt.name === updateAddressObject.subdistrict
                  ) || null
                }
                onChange={(newValue) => {
                  updateFieldAddressObj("subdistrict", newValue?.name ?? "");
                  removeInputError("input-tambolName");
                  // Reset postal code when subdistrict changes
                  updateFieldAddressObj("postCode", "");
                }}
                options={kwangOptions || []}
                getOptionLabel={(option) => option?.label ?? option?.name ?? ""}
                isOptionEqualToValue={(option, value) =>
                  option?.name === value?.name
                }
                loading={loadingKwang}
                error={inputErrors.includes("input-tambolName")}
              />
            </Grid>
          </Grid>

          <br />
          <Grid container md={12}>
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-zip"
                label="รหัสไปรษณีย์"
                placeholder="รหัสไปรษณีย์"
                value={zip}
                onChange={(newValue) => {
                  updateFieldAddressObj("postCode", newValue?.name ?? "");
                  removeInputError("input-postCode");
                }}
                disabled={!kwang}
                loading={loadingZip}
                error={inputErrors.includes("input-zip")}
              />
            </Grid>
            <br />
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-fullname"
                label="ประเทศ"
                placeholder="ประเทศ"
                value={updateAddressObject.country}
                onChange={(e) =>
                  updateFieldAddressObj("country", e.target.value)
                }
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>
          </Grid>
        </>
      );
    } else if (typeUpdate === "แก้ไขเบอร์โทร") {
      return (
        <>
          <Grid item xs={12} md={12}>
            <CustomInputText
              id="input-telephone"
              label="เบอร์โทรศัพท์มือถือ"
              placeholder="08xxxxxxxx"
              value={updateTelephoneObject.mobile_new ?? ""}
              onChange={(e) => {
                const digits = e.target.value.replace(/\D/g, "").slice(0, 10); // เอาเฉพาะ 0-9 และตัดให้เหลือ 10 หลัก
                updateFieldTelephoneObj("mobile_new", digits);
              }}
              onPaste={(e) => {
                e.preventDefault();
                const pasted = e.clipboardData
                  .getData("text")
                  .replace(/\D/g, "")
                  .slice(0, 10);
                updateFieldTelephoneObj("mobile_new", pasted);
              }}
              InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              inputProps={{
                maxLength: 10,
                inputMode: "numeric", // มือถือขึ้นคีย์บอร์ดตัวเลข
                pattern: "[0-9]*", // ช่วย browser hint ว่าต้องเป็นเลข
              }}
            />
          </Grid>
          <br />
          <Grid container md={12}>
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-phone_home_new"
                label="เบอร์โทรศัพท์บ้าน"
                placeholder="02xxxxxxxx"
                value={updateTelephoneObject.phone_home_new ?? ""}
                onChange={(e) => {
                  const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
                  updateFieldTelephoneObj("phone_home_new", digits);
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const pasted = e.clipboardData
                    .getData("text")
                    .replace(/\D/g, "")
                    .slice(0, 10);
                  updateFieldTelephoneObj("phone_home_new", pasted);
                }}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
                inputProps={{
                  maxLength: 10,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
              />
            </Grid>

            <br />

            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-phone_home_to_new"
                label=""
                placeholder="101xx"
                value={updateTelephoneObject.phone_home_to_new ?? ""}
                onChange={(e) => {
                  const digits = e.target.value.replace(/\D/g, "").slice(0, 5);
                  updateFieldTelephoneObj("phone_home_to_new", digits);
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const pasted = e.clipboardData
                    .getData("text")
                    .replace(/\D/g, "")
                    .slice(0, 5);
                  updateFieldTelephoneObj("phone_home_to_new", pasted);
                }}
                InputProps={{
                  style: {
                    borderRadius: "16px",
                    height: "42px",
                    marginTop: "30px",
                  },
                }}
                inputProps={{
                  maxLength: 5,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
              />
            </Grid>
          </Grid>

          <br />

          <Grid container md={12}>
            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-phone_office_new"
                label="เบอร์โทรศัพท์ที่่ทำงาน"
                placeholder="08xxxxxxxx"
                value={updateTelephoneObject.phone_office_new ?? ""}
                onChange={(e) => {
                  const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
                  updateFieldTelephoneObj("phone_office_new", digits);
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const pasted = e.clipboardData
                    .getData("text")
                    .replace(/\D/g, "")
                    .slice(0, 10);
                  updateFieldTelephoneObj("phone_office_new", pasted);
                }}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
                inputProps={{
                  maxLength: 10,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
              />
            </Grid>

            <br />

            <Grid item xs={6} md={6}>
              <CustomInputText
                id="input-phone_office_to_new"
                label=""
                placeholder="101xx"
                value={updateTelephoneObject.phone_office_to_new ?? ""}
                onChange={(e) => {
                  const digits = e.target.value.replace(/\D/g, "").slice(0, 5);
                  updateFieldTelephoneObj("phone_office_to_new", digits);
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const pasted = e.clipboardData
                    .getData("text")
                    .replace(/\D/g, "")
                    .slice(0, 5);
                  updateFieldTelephoneObj("phone_office_to_new", pasted);
                }}
                InputProps={{
                  style: {
                    borderRadius: "16px",
                    height: "42px",
                    marginTop: "30px",
                  },
                }}
                inputProps={{
                  maxLength: 5,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
              />
            </Grid>
          </Grid>

          <br />

          <Grid item xs={12} md={12}>
            <CustomInputText
              id="input-telephoneother"
              label="เบอร์โทรศัพท์อื่นๆ"
              placeholder="08xxxxxxxx"
              value={updateTelephoneObject.phone_other_new ?? ""}
              onChange={(e) => {
                const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
                updateFieldTelephoneObj("phone_other_new", digits);
              }}
              onPaste={(e) => {
                e.preventDefault();
                const pasted = e.clipboardData
                  .getData("text")
                  .replace(/\D/g, "")
                  .slice(0, 10);
                updateFieldTelephoneObj("phone_other_new", pasted);
              }}
              InputProps={{ style: { borderRadius: "16px", height: "40px" } }}
              inputProps={{
                maxLength: 10,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
            />
          </Grid>
        </>
      );
    }
  };

  const cardTypes = [
    { value: "AM", label: "Amex" },
    { value: "C4", label: "JCB" },
    { value: "MC", label: "Mastercard" },
    { value: "VI", label: "Visa" },
  ];

  const bankDataOptions = [
    { label: "กสิกรไทย", value: "กสิกรไทย" },
    { label: "กรุงเทพ", value: "กรุงเทพ" },
    { label: "กรุงไทย", value: "กรุงไทย" },
    { label: "ไทยพาณิชย์", value: "ไทยพาณิชย์" },
    { label: "กรุงศรีอยุธยา", value: "กรุงศรีอยุธยา" },
    { label: "ซีไอเอ็มบี", value: "ซีไอเอ็มบี" },
    { label: "ทหารไทยธนชาต", value: "ทหารไทยธนชาต" },
    { label: "ออมสิน", value: "ออมสิน" },
    { label: "ยูโอบี", value: "ยูโอบี" },
    { label: "ทิสโก้", value: "ทิสโก้" },
    { label: "อื่นๆ", value: "อื่นๆ" },
  ];
  const AddressDataOptions = [
    { label: "ที่อยู่ในการจัดส่งเอกสาร", value: "ADDR_POST" },
    { label: "ที่อยู่ตามทะเบียนบ้าน", value: "ADDR_HOME" },
    { label: "ที่อยู่ปัจจุบัน", value: "ADDR_CURRENT" },
    { label: "ที่อยู่ที่ทำงาน", value: "ADDR_OFFICE" },
    { label: "ที่อยู่อื่นๆ", value: "ADDR_OTHER" },
  ];
  const RelationDataOptions = [
    { label: "ตนเอง", value: "ตนเอง" },
    { label: "บิดา / มารดา", value: "บิดา / มารดา" },
    { label: "สามี / ภรรยา", value: "สามี / ภรรยา" },
    { label: "บุตร", value: "บุตร" },
    { label: "พี่น้องร่วมสายโลหิต", value: "พี่น้องร่วมสายโลหิต" },
  ];

  const selectedPrefixTh =
    (updateNameObject.prefix_th ?? "").trim() === ""
      ? null
      : thaiPrefixOptions.find(
          (opt) => (opt.value ?? "") === (updateNameObject.prefix_th ?? "")
        ) || null;

  const selectedPrefixEn =
    (updateNameObject.prefix_en ?? "").trim() === ""
      ? null
      : thaiPrefixOptions.find(
          (opt) => (opt.value ?? "") === (updateNameObject.prefix_en ?? "")
        ) || null;

  const getCardTypeNameByCode = (code) => {
    const findCardType = cardTypes.find((item) => item.value === code);
    return findCardType ? findCardType.label : code;
  };

  const getBankName = async () => {
    const result = await getParameterAPI(14);
    if (result.success) {
      const payload = result.payload;
      setBanks(result.payload);
      console.log(payload);
    }
  };

  return (
    <div>
      {loading ? (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={loading}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </Backdrop>
      ) : null}
      <Header_Home />
      <Header title="การเปลี่ยนแปลงข้อมูล" />
      {spinner && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </div>
      )}
      <div className="table-page-container footer-space">
        <div className="rounded-border bg-white p-2">
          {/* ปุ่มขวา */}
          <div
            id="export"
            className="text-align-right"
            style={{ marginTop: "20px" }}
          >
            <CSVLink
              data={data_csv}
              headers={headers}
              filename={generateFilename()}
              style={{ fontSize: 18 }}
              className="btn-fill-export p-2 bold"
            >
              Export File
            </CSVLink>
          </div>
          <br />
          <Grid
            container
            spacing={2}
            style={{ paddingInline: "32px", marginBottom: "15px" }}
          >
            {/* แถวที่ 1 */}
            <Grid item xs={12} md={3}>
              <CustomInputText
                id="input-policyNo"
                label="กรมธรรม์เลขที่"
                placeholder="กรมธรรม์เลขที่"
                value={policyNumber}
                onChange={(e) => setPolicyNumber(e.target.value)}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <CustomInputText
                id="input-fullname"
                label="ชื่อ นามสกุล"
                placeholder="ชื่อ นามสกุล"
                value={insurerName}
                onChange={(e) => setInsurerName(e.target.value)}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                Request Date
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่เริ่มต้น"
                  defaultValue={""}
                  value={requestStartDate || null}
                  onChange={(value) => setRequestStartDate(value)}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                &nbsp;
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่สิ้นสุด"
                  defaultValue={""}
                  value={requestEndDate || null}
                  onChange={(value) => setRequestEndDate(value)}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            {/* แถวที่ 2 */}
            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                Close Date
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่เริ่มต้น"
                  defaultValue={""}
                  value={closeStartDate || null}
                  onChange={(value) => setCloseStartDate(value)}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                &nbsp;
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่สิ้นสุด"
                  defaultValue={""}
                  value={closeEndDate || null} // ค่า value จาก state
                  onChange={(value) => setCloseEndDate(value)} // ฟังก์ชัน onChange
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                Type
              </label>
              <Select
                input={<OutlinedInput />}
                style={{ borderRadius: "16px", height: "42px" }}
                value={type}
                onChange={(e) => setType(e.target.value)}
                displayEmpty
                fullWidth
              >
                <MenuItem value="">
                  <div style={{ color: "#999" }}>ประเภทการเปลี่ยนแปลง</div>
                </MenuItem>
                {optionChangeType.map((option) => (
                  <MenuItem key={option.name} value={option.name}>
                    {option.description}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                Status
              </label>
              <Select
                input={<OutlinedInput />}
                style={{ borderRadius: "16px", height: "42px" }}
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                displayEmpty
                fullWidth
              >
                <MenuItem value="">
                  <div style={{ color: "#999" }}>สถานะ</div>
                </MenuItem>
                <MenuItem value="New">New</MenuItem>
                <MenuItem value="Taken">Taken</MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
                <MenuItem value="Canceled">Canceled</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
              </Select>
            </Grid>
          </Grid>

          <br />
          <div className="App">
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={onSearch}
                className="btn-fill-orange  p-2 bold"
              >
                ค้นหา
              </button>
              <button onClick={clear} className="btn-fill-gray p-2 bold ml-2" style={{ marginLeft: '12px' }}>
                ล้าง
              </button>
            </section>
            <br />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // ✅ ให้ปุ่มอยู่ระดับเดียวกัน
                paddingInline: "10px",
                flexWrap: "wrap", // ✅ กัน overflow บนจอเล็ก
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {/* ปุ่มซ้าย */}
              <section
                className="filter-action-section"
                style={{ display: "flex", gap: "10px" }}
              >
                <button
                  style={{ fontSize: 18 }}
                  onClick={handleUpdateTaken}
                  className={
                    isDisabledTaken
                      ? "btn-fill-gray p-2 bold"
                      : "btn-fill-orange p-2 bold"
                  }
                  disabled={isDisabledTaken}
                >
                  Taken Owner
                </button>
                <button
                  style={{ fontSize: 18 }}
                  onClick={handleSubmit}
                  className={
                    isDisabledSubmit
                      ? "btn-fill-gray p-2 bold"
                      : "btn-fill-green p-2 bold"
                  }
                  disabled={isDisabledSubmit}
                >
                  Submit
                </button>

                <button
                  style={{ fontSize: 18 }}
                  onClick={handleCancel}
                  className={
                    isDisabledSubmit
                      ? "btn-fill-gray p-2 bold"
                      : "btn-fill-orange p-2 bold"
                  }
                  disabled={isDisabledSubmit}
                >
                  Cancel
                </button>
              </section>
            </div>

            {LoadingContent ? (
              <div className="p-4">
                <div className="p-2">
                  <Skeleton className="h-70px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                </div>
              </div>
            ) : (
              <ThemeProvider theme={theme}>
                <TableContainer style={{ height: "auto" }} component={Paper}>
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#e7e7e786" }}>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "3%" }}
                        >
                          Select
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "10%" }}
                        >
                          Policy Number
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "30%" }}
                        >
                          Insure Name
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "30%" }}
                        >
                          Type
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "20%" }}
                        >
                          Request Date
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "20%" }}
                        >
                          Close Date
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "10%" }}
                        >
                          Taken/Close by
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "20%" }}
                        >
                          Status
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "10%" }}
                        >
                          Link
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "10%" }}
                        >
                          Detail
                        </TableCell>

                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: "20%" }}
                        >
                          Edit
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {!(dataTable.length === 0) ? (
                        dataTable
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((item, idx) => {
                            const seq = idx + 1 + page * rowsPerPage;
                            return (
                              <TableRow key={idx}>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "3%" }}
                                >
                                  <input
                                    type="checkbox"
                                    value={item.id}
                                    id={item.id}
                                    name={item.id}
                                    onChange={(event) =>
                                      handleCheckboxChange(event, item.id)
                                    }
                                    className="checkbox-large margin-left-px mt-1"
                                    disabled={
                                      (item.close_date ? true : false) ||
                                      (item.status === "Canceled"
                                        ? true
                                        : false)
                                    }
                                    checked={selectedRows.includes(item.id)}
                                  />
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "10%" }}
                                >
                                  {item.policy_number}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "30%" }}
                                >
                                  {item.insurer_name}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "30%" }}
                                >
                                  {item.subject}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "20%" }}
                                >
                                  {item.request_date
                                    ? moment(item.request_date).format(
                                        "DD/MM/YYYY HH:mm"
                                      )
                                    : "-"}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "20%" }}
                                >
                                  {item.close_date
                                    ? moment(item.close_date).format(
                                        "DD/MM/YYYY"
                                      )
                                    : "-"}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "20%" }}
                                >
                                  {item.status_by ? item.status_by : "-"}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "10%" }}
                                >
                                  <span
                                    style={{
                                      color:
                                        item.status === "New"
                                          ? "#FA0E0E"
                                          : item.status === "Taken"
                                          ? "#FF5E43"
                                          : item.status === "Closed"
                                          ? "#12B71D"
                                          : "black",
                                    }}
                                  >
                                    {item.status}
                                  </span>
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "10%" }}
                                >
                                  {item.link ? (
                                    <a
                                      href={item.link}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Document
                                    </a>
                                  ) : (
                                    "-"
                                  )}
                                </TableCell>

                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: "10%" }}
                                >
                                  {item.id_detail ? (
                                    <a
                                      className="link-event"
                                      onClick={() =>
                                        toggleModalDetailOpen(
                                          item.id_detail,
                                          item.type,
                                          item.policy_number,
                                          item.subject
                                        )
                                      }
                                    >
                                      Detail
                                    </a>
                                  ) : (
                                    "-"
                                  )}
                                </TableCell>
                                <TableCell
                                  className="link-event"
                                  align="center"
                                  style={{ width: "10%" }}
                                >
                                  {item.status === "Taken" ? (
                                    <EditOutlinedIcon
                                      sx={{ color: "#f5e43" }}
                                      onClick={() => {
                                        handleClickOpen(
                                          item.id_detail,
                                          item.type,
                                          item.insurer_name,
                                          item.subject
                                        );
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          })
                      ) : (
                        <TableCell align="center" colSpan={12}>
                          <span className="font-new">ไม่พบข้อมูล</span>
                        </TableCell>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={dataTable.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </ThemeProvider>
            )}
          </div>
        </div>
        <Modal
          size="xl"
          show={showModalDetail}
          onHide={toggleModalDetailClose}
          centered
        >
          <Modal.Header closeButton>
            <h5 className="bold" style={{ color: "#ff5e43" }}>
              {selectedDetail.subject}
            </h5>
            {/* <Modal.Title>ตรวจสอบสำเร็จ</Modal.Title> */}
          </Modal.Header>
          <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color: "#ff5e43",
            }}
          />
          <Modal.Body>
            <TableDetail
              id_detail={selectedDetail.id_detail}
              type={selectedDetail.type}
              policy_number={selectedDetail.policy_number}
            />

            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleModalDetailClose}
                className="btn-fill-orange  p-2 bold"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>
        <Modal
          size="xl"
          show={showModalDetail}
          onHide={toggleModalDetailClose}
          centered
          backdrop={false}
        >
          <Modal.Header closeButton>
            <h5 className="bold" style={{ color: "#ff5e43" }}>
              {selectedDetail.subject}
            </h5>
          </Modal.Header>
          <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color: "#ff5e43",
            }}
          />
          <Modal.Body>
            <TableDetail
              id_detail={selectedDetail.id_detail}
              type={selectedDetail.type}
              policy_number={selectedDetail.policy_number}
            />

            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleModalDetailClose}
                className="btn-fill-orange  p-2 bold"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>

        <Modal show={showModal} onHide={toggleModalClose} centered>
          <Modal.Header closeButton>
            <h5 className="bold" style={{ color: "#ff5e43" }}>
              Taken
            </h5>
            {/* <Modal.Title>ตรวจสอบสำเร็จ</Modal.Title> */}
          </Modal.Header>
          <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color: "#ff5e43",
            }}
          />
          <Modal.Body>
            <img
              src={successGif}
              alt={"confirmGif"}
              style={{
                height: "auto",
                marginLeft: "35%",
                width: "30%",
              }}
            />
            <li
              className="body-list-group"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Col
                xl={12}
                md={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <h3 className="bold">ระบบบันทึกข้อมูลเรียบร้อย</h3>
              </Col>
            </li>
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleModalClose}
                className="btn-fill-orange  p-2 bold"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>
        <Modal show={showSubmitModal} onHide={toggleSubmitModalClose} centered>
          <Modal.Header closeButton>
            <h5
              className="bold"
              style={{
                color:
                  submitStatus === "success"
                    ? "#28a745"
                    : submitStatus === "partial"
                    ? "#ffc107"
                    : "#dc3545",
              }}
            >
              Submit
            </h5>
          </Modal.Header>
          <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color:
                submitStatus === "success"
                  ? "#28a745"
                  : submitStatus === "partial"
                  ? "#ffc107"
                  : "#dc3545",
            }}
          />
          <Modal.Body>
            <img
              src={
                submitStatus === "success"
                  ? successGif
                  : submitStatus === "partial"
                  ? warning
                  : remove
              } // ตั้ง errorGif ให้เหมาะสม
              alt={"submitStatusGif"}
              style={{
                height: "auto",
                marginLeft: "35%",
                width: "30%",
              }}
            />
            <li
              className="body-list-group"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Col
                xl={12}
                md={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  {submitStatus === "success" ? (
                    <>
                      <h3 className="bold" style={{ margin: 0 }}>
                        ระบบบันทึกข้อมูลเรียบร้อย
                      </h3>
                      <h3 className="bold" style={{ margin: 0 }}>
                        ({submitSuccessCount} รายการ)
                      </h3>
                    </>
                  ) : (
                    <>
                      <h3 className="bold" style={{ margin: 0 }}>
                        ไม่สามารถบันทึกข้อมูลได้
                      </h3>
                      <br />
                      <h3 className="bold" style={{ margin: 0 }}>
                        สำเร็จ {submitSuccessCount} รายการ
                        <br />
                        <br />
                        ไม่สำเร็จ {submitFailCount} รายการ
                      </h3>
                    </>
                  )}
                  {submitStatus === "error" ||
                    (submitStatus === "partial" && errorItems.length > 0 && (
                      <ThemeProvider theme={theme}>
                        <TableContainer
                          component={Paper}
                          style={{
                            marginTop: "20px",
                            maxHeight: "240px", // ประมาณ 5 แถว
                            overflowY: "auto",
                          }}
                        >
                          <Table
                            stickyHeader
                            aria-label="error table"
                            size="small"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  align="center"
                                  sx={{
                                    backgroundColor: "#f5f5f5",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ลำดับ
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    backgroundColor: "#f5f5f5",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Policy No.
                                </TableCell>
                                {/* <TableCell
                              sx={{
                                backgroundColor: "#f5f5f5",
                                fontWeight: "bold",
                              }}
                            >
                              Insure ID Card
                            </TableCell> */}
                                <TableCell
                                  align="center"
                                  sx={{
                                    backgroundColor: "#f5f5f5",
                                    fontWeight: "bold",
                                  }}
                                >
                                  สาเหตุ
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {errorItems.map((item, index) => (
                                <TableRow key={index}>
                                  <TableCell align="center">
                                    {index + 1}
                                  </TableCell>
                                  <TableCell>{item.policyNo}</TableCell>
                                  {/* <TableCell>{item.insureIdCard}</TableCell> */}
                                  <TableCell>{item.errorMessage}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </ThemeProvider>
                    ))}
                </div>
              </Col>
            </li>
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleSubmitModalClose}
                className="btn-fill-orange  p-2 bold"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>
      </div>

      <Modal
        show={showSubmitEditModal}
        onHide={toggleSubmitEditModalClose}
        centered
      >
        <Modal.Body>
          <img
            src={
              submitStatus === "success"
                ? successGif
                : submitStatus === "partial"
                ? warning
                : remove
            } // ตั้ง errorGif ให้เหมาะสม
            alt={"submitStatusGif"}
            style={{
              height: "auto",
              marginLeft: "35%",
              width: "30%",
            }}
          />
          <li
            className="body-list-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col
              xl={12}
              md={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <div style={{ textAlign: "center" }}>
                {submitStatus === "success" ? (
                  <>
                    <h3 className="bold" style={{ margin: 0 }}>
                      {"ระบบแก้ไขข้อมูลเรียบร้อย"}
                    </h3>
                  </>
                ) : (
                  <>
                    <h3 className="bold" style={{ margin: 0 }}>
                      <br />

                      {"ไม่สามารถแก้ไขข้อมูลได้"}
                    </h3>
                  </>
                )}
              </div>
            </Col>
          </li>
          <section className="filter-action-section">
            <button
              style={{ fontSize: 18 }}
              onClick={toggleSubmitEditModalClose}
              className="btn-fill-orange  p-2 bold"
            >
              ตกลง
            </button>
          </section>
        </Modal.Body>
      </Modal>

      <Modal show={showCancelModal} onHide={toggleCancelModalClose} centered>
        <Modal.Body>
          <img
            src={warning /* ใช้ไอคอน/รูปเตือนที่คุณมี เช่น warning */}
            alt="confirm-cancel"
            style={{ height: "auto", marginLeft: "35%", width: "30%" }}
          />

          <li
            className="body-list-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col
              xl={12}
              md={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <h3 className="bold" style={{ margin: 0 }}>
                  ยืนยันการ cancel?
                </h3>
              </div>
            </Col>
          </li>

          <section
            className="filter-action-section"
            style={{ display: "flex", gap: 12, justifyContent: "center" }}
          >
            <button
              style={{ fontSize: 18 }}
              onClick={toggleCancelModalClose}
              className="btn-fill-gray p-2 bold"
            >
              ยกเลิก
            </button>

            <button
              style={{ fontSize: 18 }}
              onClick={handleConfirmCancel}
              className="btn-fill-orange p-2 bold"
            >
              ตกลง
            </button>
          </section>
        </Modal.Body>
      </Modal>

      <Modal size="xl" show={open} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <h5 className="bold" style={{ color: "#ff5e43" }}>
            {typeUpdate}
          </h5>
        </Modal.Header>
        <hr
          style={{
            margin: "0px 10px 0px 5px",
            border: "solid 2px",
            borderTop: 0.1,
            color: "#ff5e43",
          }}
        />
        <Modal.Body>
          {renderInputForEdit()}

          <section className="filter-action-section">
            <button
              style={{ fontSize: 18 }}
              onClick={Cancelpersona}
              className="btn-fill-gray p-2 bold ml-2"
            >
              ยกเลิก
            </button>
            &nbsp;&nbsp;
            <button
              style={{ fontSize: 18 }}
              onClick={() => {
                updatepersona();
              }}
              className="btn-fill-orange  p-2 bold"
            >
              บันทึก
            </button>
          </section>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ChangeInformation;
